// extracted by mini-css-extract-plugin
export default {"root":"Container_root__ijr4X"};